import React, { Fragment, useState, useEffect } from "react";
import { render } from "react-dom";

import { Input } from "../../../../../../prototype/src/atoms/Input";
import { Button } from "../../../../../../prototype/src/atoms/Button";

import phoneicon from '../../../../../../prototype/src/assets/images/icon-phone.svg';
import faxicon from '../../../../../../prototype/src/assets/images/icon-fax.svg';
import iconsearch from '../../../../../../prototype/src/assets/images/icon-search-2.svg';

import { getSettings } from "../../../../../scripts/util/getSettings";

const directoryEntryGroups = getSettings(['vmc', 'directoryEntryGroups']);

const hasItemsThatStartWith = (directoryEntryGroup, term) => {
    if (term) {
        var hasItem = directoryEntryGroup.Entries.filter(x => x.DirectoryEntryName.toLowerCase().indexOf(term.toLowerCase()) >= 0).length > 0;
        return hasItem;
    }
};

const Component = () => {

  const [keyword, setkeyword] = useState('');
  const [filter, setFilter] = useState('all');

  const searchChange = e => {
    setkeyword(e.target.value);
  };

  useEffect(() => {
    if (keyword) {
      setFilter('all');
    }
  }, [keyword])

  const renderGroup = (letter, entries, i) => {
    const noEntries= entries.length === 0;
    return (
      <div key={i} name={letter} className={noEntries ? 'az_filter_bottom_main_item az_filter_disable' : 'az_filter_bottom_main_item'}>
        <ul>
          {entries.map((entry, idx) => {
            return (
              <li key={idx}>
                <div className="az_filter_bottom_list">
                  <div className="az_filter_bottom_list_item">
                    {entry.DirectoryEntryLinkUrl && <a href={entry.DirectoryEntryLinkUrl}>{entry.DirectoryEntryName}</a>}
                    {!entry.DirectoryEntryLinkUrl && <Fragment>{entry.DirectoryEntryName}</Fragment>}
                  </div>
                  <div className="az_filter_bottom_list_item">
                    <div className="az_filter_bottom_list_item_contact">
                      {entry.DirectoryEntryPhone && <div className="az_filter_bottom_c1">
                        <a href={`tel:${entry.DirectoryEntryPhone}`}>
                          <img src={phoneicon} alt="" />
                          {entry.DirectoryEntryPhone}
                        </a>
                      </div>}
                      {entry.DirectoryEntryFax && <div className="az_filter_bottom_c2">
                        <img src={faxicon} alt="" /> {entry.DirectoryEntryFax}
                      </div>}
                    </div>
                  </div>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    );
  };

  return (
    <div>
      <div className="az_filter">
        <div className="az_filter_content">
          <div className="az_filter_top_content">
            <ul className="az_filter_alphabet">
              {directoryEntryGroups.map((item, i) => {
                const noEntries = item.Entries.length === 0;
                let itemClass = 'az_filter_alphabet_box';
                if (noEntries) {
                  itemClass = 'az_filter_alphabet_box az_filter_disabled';
                  return (<li key={i}><div className={itemClass}>{item.Letter}</div></li>);
                }
                return (<li key={i} className={filter === item.Letter ? 'selected' : ''} onClick={() => setFilter(item.Letter)}><div className={itemClass}>{item.Letter}</div></li>);
              })}
            </ul>
            <Button className={'primary az_filter_btn'} label={'View All'} onClick={() => {
              setkeyword('');
              setFilter('all');
            }} />
          </div>
          <div className="az_filter_mid_content">
            <div className="az_filter_search">
              <div className="az_filter_search_box">
                <Input 
                  className={'default'} 
                  placeholder={'Search keyword'} 
                  value={keyword} 
                  onChange={searchChange}
                  maxLength={100} />
                <img className="az_search_icon" src={iconsearch} alt="" />
              </div>
            </div>
          </div>
          <div className="az_filter_bottom_content">
            <div className="az_filter_bottom_info">
              {directoryEntryGroups.map((item, i) => {
                if (hasItemsThatStartWith(item, keyword)) {
                  let filteredEntries = JSON.parse(JSON.stringify(item.Entries));
                  filteredEntries = filteredEntries.filter(x => x.DirectoryEntryName.toLowerCase().indexOf(keyword.toLowerCase()) >= 0);
                  return renderGroup(item.Letter, filteredEntries, i);
                }
                if (!keyword && (filter === 'all' || filter === item.Letter)) {
                  return renderGroup(item.Letter, item.Entries, i);
                }
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

render(
  <Component />,
  document.getElementById("atozDirectory")
);
